module.exports = __webpack_public_path__ + "img/no-records-team-members.500be570.webp";